import { Box, Flex } from '@mantine/core'

import {
  useAcceptNotification,
  useRejectNotification,
} from '@/modules/actionPlan/pages/components/NotificationItem/NotificationItem.config'
import type { NotificationItemProps } from '@/modules/actionPlan/pages/components/NotificationItem/NotificationItem.types'

import { Button } from '@/components/Button/Button'
import { Text } from '@/components/Text/Text'
import { Title } from '@/components/Title/Title'

import classes from './NotificationItem.module.css'

export function NotificationItem({
  item: { body, id, params, title },
}: NotificationItemProps) {
  const { rejectNotification } = useRejectNotification(id)
  const { acceptNotification } = useAcceptNotification(id, +params.param)

  return (
    <Flex
      key={id}
      className={classes.container}
      direction="column"
      justify="space-between"
    >
      <Box>
        <Title variant="h5">{title}</Title>

        <Text variant="body_2_black">
          <span
            dangerouslySetInnerHTML={{
              __html: body,
            }}
          />
        </Text>
      </Box>

      <Flex className={classes.buttons} gap={8}>
        <Button onClick={rejectNotification} variant="outline-small">
          Reject
        </Button>

        <Button onClick={acceptNotification} variant="primary-small">
          Accept
        </Button>
      </Flex>
    </Flex>
  )
}
